class AppBarConfigVM {
    customerName: string;
    customerLogo: string;
    companyId: number;
    companyName: string;
    appLogo: string;
    appTitle: string;
    centralTitle: KnockoutObservable<string>;
    multiTenant: boolean;

    get isLogoVisible(): boolean {
        return this.customerLogo && this.customerLogo.length > 0;
    }

    constructor(data: any) {
        this.customerName = data.customerName;
        this.customerLogo = data.customerLogo;
        this.companyId = data.companyId; //Use the loggedUser.companyId()
        this.companyName = data.companyName;//Use the loggedUser.companyName()
        this.appTitle = data.appTitle;
        this.centralTitle = ko.observable(data.centralTitle);
        this.multiTenant = data.multiTenant; //Use the irSettings.multiTenant

        this.appLogo = urlConfigs.logoSmall;
    }
}